import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { formatRosterMonth } from './rosterUtils';

const RosterToolbar = ({ year, month, onPrevious, onNext, onToday, isCurrentMonth }) => (
  <div className="flex flex-wrap items-center gap-2" aria-label="Maandnavigatie">
    {!isCurrentMonth && (
      <Button type="button" variant="ghost" size="sm" onClick={onToday} className="mr-1 text-teal-700 hover:bg-teal-50 hover:text-teal-800">
        Deze maand
      </Button>
    )}
    <Button type="button" variant="outline" size="icon" onClick={onPrevious} aria-label="Vorige maand" className="h-10 w-10">
      <ChevronLeft className="h-4 w-4" />
    </Button>
    <p className="min-w-36 text-center text-sm font-semibold capitalize text-slate-800" aria-live="polite">
      {formatRosterMonth(year, month)}
    </p>
    <Button type="button" variant="outline" size="icon" onClick={onNext} aria-label="Volgende maand" className="h-10 w-10">
      <ChevronRight className="h-4 w-4" />
    </Button>
  </div>
);

export default RosterToolbar;

